import Loading from "@/components/loading/loading";
import { DisposeBag } from "@/utils/manager/dispose-bag";
import { InitializationStateManager } from "@/utils/manager/initialization-state-manager";
import { ReactNode, useEffect, useMemo, useState } from "react";

export function InitializationStateComponent({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(true);
  const initializationStateManager = useMemo(() => InitializationStateManager.getInstance(), []);

  useEffect(() => {
    const disposeBag = new DisposeBag();
    initializationStateManager.isCompletedInitialization
      .subscribe((isCompleted) => setIsLoading(!isCompleted))
      .disposed(disposeBag);
    void initializationStateManager.startInitialization();
    return () => disposeBag.dispose();
  }, [initializationStateManager]);

  if (isLoading) return <Loading />;
  return children;
}
